import { QueryClientProvider } from "@tanstack/react-query";
import {
  RouterProvider,
  createBrowserHistory,
  createRouter,
} from "@tanstack/react-router";
import { queryClient } from "./lib/query-client";
import { routeTree } from "./routeTree.gen";

/**
 * iOS Safari / PWA のスワイプバックジェスチャーを無効化するためのヒストリー。
 * push を replace に差し替えて履歴スタックを常に1エントリに保つことで、
 * 戻り先が存在しない状態を作りジェスチャーの発動を防ぐ。
 */
const createReplaceOnlyHistory = () => {
  const base = createBrowserHistory();
  const noop = () => {};
  return new Proxy(base, {
    get(target, prop, receiver) {
      if (prop === "push") return Reflect.get(target, "replace", receiver);
      if (prop === "back" || prop === "forward" || prop === "go") return noop;
      return Reflect.get(target, prop, receiver);
    },
  });
};

const router = createRouter({
  routeTree,
  context: { queryClient },
  history: createReplaceOnlyHistory(),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>
);
